import { Component, input } from "@angular/core";
import { Color } from "@ionic/core";

import { SubmitResponseAction, SubmitResponseActionInfo } from "../../model/submitFormResponse";
import { SafeHtmlPipe } from "../../pipes/safe-html.pipe";
import { IonButton, IonButtons, IonContent, IonText } from "@ionic/angular/standalone";

@Component({
    selector: "app-html-message-page",
    templateUrl: "./html-message.page.html",
    styleUrls: ["./html-message.page.scss"],
    imports: [SafeHtmlPipe, IonContent, IonText, IonButtons, IonButton],
})
export class HtmlMessagePage {
    readonly message = input<string>("");
    readonly color = input<Color>("dark");
    readonly actions = input<SubmitResponseActionInfo[]>([]);

    takeAction(action: SubmitResponseAction): void {
        if (action === SubmitResponseAction.SHOW_START_OVER_BUTTON) {
            location.reload();
        }
    }
}
